import { DynamicTranslatableName } from 'constants/_types/DynamicTranslatableName';

const convertStringToDynamicTranslatableName = (string = ''): DynamicTranslatableName => ({ id: 0, key: string, defaultValue: string });

export default convertStringToDynamicTranslatableName;
